'use client';

import { c as _c } from "react/compiler-runtime";
import { Rail } from '@src/components/Rail/Rail';
import { SKUSelectionRailDefaults } from '@src/components/SKUSelectionRail/SKUSelectionRail.defaults';
import type { SKUSelectionRailProps } from '@src/components/SKUSelectionRail/SKUSelectionRail.props';
import { SKUSelectionRailItem } from '@src/components/SKUSelectionRail/SKUSelectionRailItem/SKUSelectionRailItem';
import { useOnMount } from '@src/hooks/useOnMount';
import { useSKUSelectionStore } from '@src/stores/SKUSelectionStore';
export const SKUSelectionRail = t0 => {
  const $ = _c(19);
  const props = t0 === undefined ? SKUSelectionRailDefaults : t0;
  const {
    railProps,
    items,
    maxSelection,
    minSelection,
    builderBlock
  } = props;
  const slug = railProps.slug;
  const setupGroup = useSKUSelectionStore(_temp);
  let t1;
  if ($[0] !== maxSelection || $[1] !== minSelection || $[2] !== setupGroup || $[3] !== slug) {
    t1 = () => {
      if (!slug) {
        return;
      }
      setupGroup(slug, minSelection ?? 1, maxSelection ?? 1);
    };
    $[0] = maxSelection;
    $[1] = minSelection;
    $[2] = setupGroup;
    $[3] = slug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useOnMount(t1);
  let t2;
  if ($[5] !== builderBlock || $[6] !== items || $[7] !== railProps.columnsDesktop || $[8] !== railProps.imageStyle || $[9] !== railProps.slug) {
    let t3;
    if ($[11] !== builderBlock || $[12] !== railProps.columnsDesktop || $[13] !== railProps.imageStyle || $[14] !== railProps.slug) {
      t3 = (item, i) => ({
        blocks: [<SKUSelectionRailItem key={i} imageAlt={item.imageAlt} blocks={item.blocks} columnsDesktop={railProps.columnsDesktop} imageStyle={railProps.imageStyle} imageUrl={item.imageUrl} sku={item.sku} railSlug={railProps.slug} builderBlock={builderBlock} />]
      });
      $[11] = builderBlock;
      $[12] = railProps.columnsDesktop;
      $[13] = railProps.imageStyle;
      $[14] = railProps.slug;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = items.map(t3);
    $[5] = builderBlock;
    $[6] = items;
    $[7] = railProps.columnsDesktop;
    $[8] = railProps.imageStyle;
    $[9] = railProps.slug;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const itemsBlocks = t2;
  let t3;
  if ($[16] !== itemsBlocks || $[17] !== railProps) {
    t3 = <Rail {...railProps} items={itemsBlocks} />;
    $[16] = itemsBlocks;
    $[17] = railProps;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
};
function _temp(state) {
  return state.setupGroup;
}